module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Bold.3a173e1f.woff2";